// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"ri_a bht_a bht_r bht_sb bht_ry bht_rz","GroupsGrid__row__item":"ri_b bht_be bht_rz"};